import { officialStandards } from "./defensieStandards";

const officialRow = (profileId, requirementId) => {
  const requirement = officialStandards[profileId].requirements.find(
    (item) => item.id === requirementId,
  );
  return {
    label: requirement.label,
    minimumValue: requirement.minimumValue,
    minimumLabel: requirement.minimumLabel,
  };
};

export const standardProfiles = [
  {
    id: "mariniers",
    label: "Korps Mariniers",
    standard: officialStandards.mariniers,
    rows: [
      {
        ...officialRow("mariniers", "run"),
        targetLabel: "3000m tot 3200m",
        targetLow: 3000,
        targetHigh: 3200,
        maxValue: 3400,
      },
      {
        ...officialRow("mariniers", "pullups"),
        targetLabel: "8 tot 12 strict",
        targetLow: 8,
        targetHigh: 12,
        maxValue: 14,
      },
      {
        ...officialRow("mariniers", "pushups"),
        targetLabel: "50 tot 60",
        targetLow: 50,
        targetHigh: 60,
        maxValue: 70,
      },
      {
        ...officialRow("mariniers", "situps"),
        targetLabel: "50 tot 60",
        targetLow: 50,
        targetHigh: 60,
        maxValue: 70,
      },
    ],
  },
  {
    id: "kct",
    label: "KCT",
    standard: officialStandards.kct,
    rows: [
      {
        ...officialRow("kct", "run"),
        targetLabel: "3100m tot 3300m",
        targetLow: 3100,
        targetHigh: 3300,
        maxValue: 3500,
      },
      {
        ...officialRow("kct", "pullups"),
        targetLabel: "12+ strict",
        targetLow: 12,
        targetHigh: 14,
        maxValue: 14,
      },
      {
        ...officialRow("kct", "pushups"),
        targetLabel: "60+",
        targetLow: 60,
        targetHigh: 70,
        maxValue: 70,
      },
      {
        ...officialRow("kct", "situps"),
        targetLabel: "60+",
        targetLow: 60,
        targetHigh: 70,
        maxValue: 70,
      },
    ],
  },
];

export const profileComponents = [
  "Belastbaarheid / rucking",
  "Hardlopen",
  "Trekkracht bovenlichaam",
  "Duwkracht / herhalingsuithouding",
  "Onderlichaam kracht",
  "Romp / herhalingscapaciteit",
  "Zwemvaardigheid",
  "Mentale tolerantie",
];

export const preparationProfiles = [
  {
    id: "candidate",
    label: "Voorbeeldprofiel kandidaat",
    description: "Fictief en ongelijk verdeeld voorbeeldprofiel.",
    color: "#d8d8d8",
    values: [38, 85, 42, 58, 35, 52, 25, 60],
  },
  {
    id: "target",
    label: "Mission Movement richtprofiel",
    description: "Sterke, gebalanceerde basis zonder perfectie te suggereren.",
    color: "#ffcc01",
    values: [82, 80, 78, 80, 78, 76, 72, 80],
  },
];
